import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Unit Plan Details
 * (/property/:propertyID/unit-plan/:unitPlanID)
 */
export const unitPlanDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_UnitPlanDetails_Welcome_Title"),
    description: t("Tour_UnitPlanDetails_Welcome_Description"),
    target: () => queryTourTarget("unit-plan-details-header"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitPlanDetails_Tabs_Title"),
    description: t("Tour_UnitPlanDetails_Tabs_Description"),
    target: () => queryTourTarget("unit-plan-details-tabs"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitPlanDetails_Link_Title"),
    description: t("Tour_UnitPlanDetails_Link_Description"),
    target: () => queryTourTarget("unit-plan-link-units"),
    placement: "left",
  },
];
